import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.el.addEventListener( 'click', e => navigator.clipboard.writeText(this.el.dataset.href ) );
    }
    init() {}
    destroy(){}
}
